import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {
  ActionBlockAmp, ActionBlockCrm, ActionBlockDashboard, ActionBlockGrapeshot, ActionBlockGraphExpansion,
  ActionBlockHouseholding, ActionBlockPoi, ActionBlockStoreVisitation, ActionBlockTrueReach
} from '../../components/ActionBlock';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';

/**
 * The home page shows a list of available services to which the user might or might not have access.
 * In case of no access, the service will link to a promo page
 */
class Home extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  static contextTypes = {
    acl: PropTypes.object.isRequired,
  };

  render() {
    let { acl } = this.context;
    const { history } = this.props;
    // If none are inactive, then we shouldn't show the 'AVAILABLE SERVICES' header
    const anyInactive = (
      !acl.amp ||
      !acl.dashboard ||
      !acl.cross_channel ||
      !acl.poi ||
      !acl.crm_onboarding ||
      !acl.partner_grapeshot ||
      !acl.householding ||
      !acl.truereach ||
      !acl.graph_expansion
    );
    const styles = {
      blockContainer : {
        display: 'flex', alignItems: 'center',
        flexDirection: 'row', flexWrap: 'wrap',
        flexFlow: 'row wrap',
      },
      contentBlock : {
        paddingTop: 40,
      },
      h2: {
        marginBottom: 0,
      },
      h3: {
        marginTop: 5,
        marginBottom: 40,
      },
      availableToolsHeader: {
        color: '#aaa',
      },
    };
    return (
      <div>
        <div className="PageHeading">
          <h1>Home</h1>
          <h2 style={styles.h2}>Welcome to the Screen6 Hub</h2>
          <h3 style={styles.h3}>Data Hookups Happen Here</h3>
        </div>
        <Paper className="ContentSpacing" style={styles.contentBlock}>
          <div style={styles.blockContainer}>
            {acl.dashboard && <ActionBlockDashboard history={history} active={acl.dashboard} />}
            {acl.amp && <ActionBlockAmp history={history} active={acl.amp} />}
            {acl.cross_channel && <ActionBlockStoreVisitation history={history} active={acl.cross_channel} />}
            {acl.poi && <ActionBlockPoi history={history} active={acl.poi} />}
            {acl.crm_onboarding && <ActionBlockCrm history={history} active={acl.crm_onboarding}/>}
            {acl.partner_grapeshot && <ActionBlockGrapeshot history={history} active={acl.partner_grapeshot}/>}
            {acl.householding && <ActionBlockHouseholding history={history} active={acl.householding}/>}
            {acl.truereach && <ActionBlockTrueReach history={history} active={acl.truereach}/>}
            {acl.graph_expansion && <ActionBlockGraphExpansion history={history} active={acl.graph_expansion}/>}
          </div>
          {anyInactive && (
            <div><br/><Divider/><h3 style={styles.availableToolsHeader}>Available Tools</h3>
            </div>
          )}
          <div style={styles.blockContainer}>
            {!acl.dashboard && <ActionBlockDashboard history={history} active={acl.dashboard}/>}
            {!acl.amp && <ActionBlockAmp history={history} active={acl.amp}/>}
            {!acl.cross_channel && <ActionBlockStoreVisitation history={history} active={acl.cross_channel}/>}
            {!acl.poi && <ActionBlockPoi history={history} active={acl.poi}/>}
            {!acl.crm_onboarding && <ActionBlockCrm history={history} active={acl.crm_onboarding}/>}
            {!acl.partner_grapeshot && <ActionBlockGrapeshot history={history} active={acl.partner_grapeshot}/>}
            {!acl.householding && <ActionBlockHouseholding history={history} active={acl.householding}/>}
            {!acl.truereach && <ActionBlockTrueReach history={history} active={acl.truereach}/>}
            {!acl.graph_expansion && <ActionBlockGraphExpansion history={history} active={acl.graph_expansion}/>}
         </div>
        </Paper>
      </div>
    )
  }
}

export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/containers/HomePage/index.jsx